import React, {Component} from 'react';
import {
    Button,
    Input,
    FormGroup,
    Form
} from 'reactstrap';
import PropTypes from 'prop-types';
import FormWrapper from "../../commonComponents/formWrapper/FormWrapper.container";
import {Link} from "react-router-dom";
import _ from "lodash";
import {sharedLabelsPath} from "../../../reducers/common/localization";
import './RestoreAccount.css';
import BackButtonComponent from "../../commonComponents/backButtonComponent/BackButtonComponent";

class RestoreAccount extends Component {
    constructor(props) {
        super(props);
        this.state = {
            email: props.email
        };
    }

    render() {
        return (
            <div className='restore-account-container'>
                <div>
                    <BackButtonComponent path='/login' label={_.get(this.props.translation, 'login.back_to_login_button')}/>
                    <div className="restore-account-form-container">
                        <div className="restore-account-form">
                            <FormWrapper successMessage={_.get(this.props.translation, 'restore_account.success_message')}>
                                <Form onSubmit={this.handleSubmit}>
                                    <h5 className="page-label">{_.get(this.props.translation, 'restore_account.label')}</h5>
                                    <FormGroup>
                                        <Input type="email" value={this.state.email} onChange={this.handleEmailChange}
                                               required
                                               placeholder={_.get(this.props.translation, sharedLabelsPath.email_label)}/>
                                    </FormGroup>
                                    <Button type="submit" block
                                            className="olive-green-btn">{_.get(this.props.translation, 'restore_account.submit_button')}</Button>
                                </Form>
                            </FormWrapper>
                            <div className="help-message-container">
                                {_.get(this.props.translation, 'restore_account.link_to_help_text')}
                                <Link to='/support'>{_.get(this.props.translation, 'restore_account.link_to_help')}</Link>
                                {_.get(this.props.translation, 'restore_account.link_to_help_end')}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    componentWillReceiveProps(nextProps) {
        this.setState({email: nextProps.email})
    }

    handleEmailChange = (e) => {
        this.setState({email: e.target.value});
    };

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.onRestoreAccount(this.state.email);
    };
}

RestoreAccount.propTypes = {
    onRestoreAccount: PropTypes.func.isRequired,
    translation: PropTypes.object.isRequired
};

export default RestoreAccount;



// WEBPACK FOOTER //
// ./src/components/accountManagement/restoreAccount/RestoreAccount.js